import { Mapper } from '../../../../domain/adapters/mapper.adapter';
import {
  ListingModel,
  ListingCollectionModel,
} from '../../../../domain/models/listing.model';
import { GetListingsResponse } from '../listings.responses';

export class ListingResponseMapper extends Mapper<
  GetListingsResponse,
  ListingCollectionModel
> {
  mapFrom(param: GetListingsResponse): ListingCollectionModel {
    return {
      listings: param.data.listings.map((listing) => {
        const sortedImages = (listing.images ?? []).slice().sort((a, b) => {
          const indexA = parseInt(a.index, 10);
          const indexB = parseInt(b.index, 10);
          return indexA - indexB;
        });
        return {
          ...listing,
          // user: {
          //   id: listing.user.id,
          //   name: listing.user.name,
          //   profileImage: listing.user.profile_image,
          // },
          images: sortedImages,
          price: parseFloat(listing.price),
          is_archived: !!listing.is_archived,
        };
      }) as ListingModel[], // At the moment, the ListingModel is the same as the ListingEntity
      total: param.data.total,
    };
  }

  mapTo(param: {
    listings: ListingModel[];
    total: number;
  }): GetListingsResponse {
    throw new Error('Method not implemented.');
  }
}
